import { ImagesLoader } from './ImagesLoader';

export const ServiceSelector = {
    
    select: (service: string) => {

        let myService

        switch(service){
            case "about":
                myService = ImagesLoader.about;
                break;
            case "contacts":
                myService = ImagesLoader.contacts;
                break;
            case "services":
                // console.log('services loading images');
                myService = ImagesLoader.services;
                break;
            case "marketconnect":
                myService = ImagesLoader.marketconnect;
                break;
            case "Market Connect Web":
                myService = ImagesLoader.web;
                break;
            case "itp":
                myService = ImagesLoader.itp;
                break;
            case "Market Connect Client":
                myService = ImagesLoader.client;
                break;
            case "mifid":
                myService = ImagesLoader.mifid;
                break;
            case "compliance wks":
                myService = ImagesLoader.compliancewks;
                break;
            case "dati storici":
                myService = ImagesLoader.datistorici;
                break;
            case "book consolidato":
                myService = ImagesLoader.bookconsolidato;
                break;
            case "best execution engine":
                myService = ImagesLoader.bestexecutionengine;
                break;
            case "otc market place":
                myService = ImagesLoader.otcmarketplace;
                break;
            case "Market Connect Feed":
                myService = ImagesLoader.feed;
                break;
            case "Ftp":
                myService = ImagesLoader.ftp;
                break;
            case "Api":
                myService = ImagesLoader.api;
                break;
            case "Web Services":
                myService = ImagesLoader.webservices;
                break;
            case "Finsite":
                myService = ImagesLoader.finsite;
                break;
            case "Basic":
                myService = ImagesLoader.basic;
                break;
            case "Premium":
                myService = ImagesLoader.premium;
                break;
            case "Full":
                myService = ImagesLoader.full;
                break;
            case "Investor Relations":
                myService = ImagesLoader.investorrelations;
                break;
        }  

        return myService; 
    }
};